export default {
    SET_REFILL_HISTORY: (state, clientRefillHistory) => {
        state.clientRefillHistory = clientRefillHistory
    },
    SET_PAGINATION: (state, pagination) => {
        state.pagination = pagination
    },

    SET_LOAD: (state, isLoaded) => {
        state.isLoaded = isLoaded
    },

    SET_FILTERS: (state, filters) => {
        state.filters = filters
    },

    RESET_CLIENT_REFILL_HISTORY: (state) => {
        state.filters = {
            phoneNumber: null,
            email: null,
            fromDate: new Date(+new Date() - 2419200000).toISOString().split('T')[0],
            toDate: new Date().toISOString().split('T')[0]
        }
    }
}
